// Point d'entrée de l'interface.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { registerSW } from 'virtual:pwa-register';
// Polices de la charte (D-038), servies par l'application elle-même, sans appel à un service externe.
import '@fontsource/unbounded/500.css';
import '@fontsource/unbounded/600.css';
import '@fontsource/red-hat-text/400.css';
import '@fontsource/red-hat-text/500.css';
import '@fontsource/red-hat-text/600.css';
import '@fontsource/red-hat-text/700.css';
import './composants/theme.css';
import './composants/base.css';
import { App } from './app/App';
import { FournisseurSession } from './app/session';
import { FournisseurFiltres } from './app/filtres';
import { appliquerDensite, appliquerTaille, appliquerTheme, lireThemeCache, suivreThemeSysteme } from './app/theme';
import { ErreurApi } from './api/client';

appliquerTheme(lireThemeCache());
try {
  const densite = localStorage.getItem('ct-densite');
  if (densite === 'compacte' || densite === 'confortable') appliquerDensite(densite);
  const taille = localStorage.getItem('ct-taille');
  if (taille === 'petite' || taille === 'normale' || taille === 'grande') appliquerTaille(taille);
} catch {
  // Stockage local indisponible.
}
suivreThemeSysteme();

const client = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (n, e) => !(e instanceof ErreurApi && e.statut >= 400 && e.statut < 500) && n < 2,
      refetchOnWindowFocus: false,
    },
  },
});

// Service worker : installe la coquille de l'application (aucune donnée de l'API n'est mise en cache).
registerSW({ immediate: true });

createRoot(document.getElementById('racine')!).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <BrowserRouter>
        <FournisseurSession>
          <FournisseurFiltres>
            <App />
          </FournisseurFiltres>
        </FournisseurSession>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
